module.exports = __webpack_public_path__ + "static/img/s30.e100919f.png";